import {observer} from 'mobx-react';
import React from 'react';
import {X7PushableBlockStore} from '../X7PushableBlockStore';

type Props = {
  store: X7PushableBlockStore,
  index: number,
  first: boolean,
  last: boolean
}

@observer
export class ReorderBlockHeaderActions extends React.Component<Props> {
  render() {
    const {store, index, first, last} = this.props;
    return (
      <>
        <button type="button" className="btn btn-primary"
                onClick={() => store.reorderBlockUp(index)}
                disabled={first}>
          <span className="fas fa-arrow-up"/>
        </button>
        <button type="button" className="btn btn-primary"
                onClick={() => store.reorderBlockDown(index)}
                disabled={last}>
          <span className="fas fa-arrow-down"/>
        </button>
      </>
    );
  }

}
